import { render } from "./portfolio.vue?vue&type=template&id=0a71e9aa&scoped=true&ts=true"
import script from "./portfolio.vue?vue&type=script&lang=ts"
export * from "./portfolio.vue?vue&type=script&lang=ts"

import "./portfolio.vue?vue&type=style&index=0&id=0a71e9aa&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a71e9aa"]])

export default __exports__